var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReject({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5898 2.60218L18.5756 0.587891L10.5898 8.57361L2.60413 0.587891L0.589844 2.60218L8.57556 10.5879L0.589844 18.5736L2.60413 20.5879L10.5898 12.6022L18.5756 20.5879L20.5898 18.5736L12.6041 10.5879L20.5898 2.60218Z",
    fill: "#F37C7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReject);
export default __webpack_public_path__ + "static/media/reject.c5540fcbd720ac1dcfd3f38d16c76267.svg";
export { ForwardRef as ReactComponent };